const styles = {
  "menu-title": "_menu-title_1sgvx_8"
};
export {
  styles as default
};
//# sourceMappingURL=MenuTitle.module.css.js.map
